/* eslint-disable no-use-before-define */
/* eslint-disable react/destructuring-assignment */
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import { Box, Grid, Typography } from '@mui/material';
import StepLabel from '@mui/material/StepLabel';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import CheckIcon from '@mui/icons-material/Check';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import { colors } from '../../services/colors';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: 'white',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: 'white',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 10,
    border: 0,
    width: 2,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  padding: 0,
  alignItems: 'center',
  ...(ownerState.active && {
    backgroundColor: 'white',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundColor: 'white',
  }),
}));

interface _Stepper {
    steps: step[],
    ativo: number,
}
interface step {
    label: string;
    icon: any;
    ativo: boolean;
    passado: boolean;
}
function ColorlibStepIcon(props: StepIconProps, index: number) {
  const { active, completed, className } = props;
  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      { completed
        ? <CheckIcon sx={{ color: colors.themePrimary }} /> : <Typography variant="h6" sx={{ color: colors.themePrimary }}>{ index + 1 }</Typography>}
    </ColorlibStepIconRoot>
  );
}

function ConnectorCustom() {
  return (
    <Grid container>
      <Grid xs={8} item sx={{ display: 'flex', alignItems: 'center' }}>
        <Box />
      </Grid>
      <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%' }}>
          <ColorlibConnector sx={{
            marginLeft: 'auto', marginRight: 'auto', paddingRight: '8px', width: '2px',
          }}
          />
        </Box>
      </Grid>
    </Grid>
  );
}

export default function StepperComponent({ steps, ativo, ...rest }: _Stepper) {
  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={ativo} orientation="vertical" connector={ConnectorCustom()}>
        {steps.map((_step: step, i: number) => (
          <Step key={_step.label}>
            <Grid container>
              <Grid xs={8} item sx={{ display: 'flex', alignItems: 'center' }}>
                <Box>
                  <Typography sx={{ color: 'white' }}>{_step.label}</Typography>
                </Box>
              </Grid>
              <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center' }}>
                <StepLabel
                  StepIconComponent={(e) => ColorlibStepIcon(e, i)}
                  sx={{
                    marginLeft: 'auto', marginRight: 'auto', padding: 0, color: 'white',
                  }}
                />
              </Grid>
            </Grid>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
